import React from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash-es'

import {
  UploadComponent,
  IconComponent,
  ImageComponent,
  DefaultAvatarComponent,
} from '..'

import './UploadAvatarComponent.scss'

const renderAddIcon = () => (
  <IconComponent name="add-photo" color="AAA" size={[24, 24]} />
)

const renderEditIcon = () => (
  <IconComponent name="edit" color="AAA" size={[18, 18]} />
)

const getStyle = (size) => ({ width: size[0], height: size[1] })

const UploadAvatarComponent = (props) => {
  const { size, name, imageSrc, onChange } = props

  return (
    <div className="upload-avatar-component" style={getStyle(size)}>
      <div className="avatar-wrapper">
        {isEmpty(imageSrc) ? (
          <DefaultAvatarComponent
            identifier={name}
            width={size[0]}
            height={size[1]}
          />
        ) : (
          <ImageComponent src={imageSrc} type="background-cover" />
        )}
      </div>
      <div className="upload-wrapper">
        <UploadComponent
          customRequest={onChange}
          withPreviewImage
          isDragAndDropAllowed
          showUploadList={false}
          accept="image/*"
        >
          <div className="add-edit-icons-wrapper">
            {isEmpty(imageSrc) ? renderAddIcon() : renderEditIcon()}
          </div>
        </UploadComponent>
      </div>
      {!isEmpty(imageSrc) && (
        <div className="delete-icon-wrapper" onClick={() => onChange(null, '')}>
          <IconComponent name="delete" color="AAA" size={[10, 10]} />
        </div>
      )}
    </div>
  )
}

UploadAvatarComponent.propTypes = {
  imageSrc: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
}

UploadAvatarComponent.defaultProps = {
  size: [48, 48],
}

export default UploadAvatarComponent
